import { createSelector } from 'reselect'
import API from '../../../utils/http/api'

const REQUEST = 'steppingblocks/dashboardTasks/REQUEST'
const SUCCESS = 'steppingblocks/dashboardTasks/SUCCESS'
const FAILURE = 'steppingblocks/dashboardTasks/FAILURE'

// Initial reducer state
const initialState = {
  requestStarted: false,
  requestEnded: false,
  error: null,
  results: [],
}

// Reducer
export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestStarted: true,
        requestEnded: false,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: payload.results,
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    default:
      return _state
  }
}

// Action Performers
export const performRetrieveDashboardTasks = () => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const { results } = await API.get('/tasks/to_me', {})
    dispatch({
      type: SUCCESS,
      payload: {
        results,
      }
    })
    return results
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: {
        error: error.message,
      }
    })
  }
}

// Selectors
const dashboardTasks = state => state.dashboardTasks

export const getDashboardTasks = createSelector(
  dashboardTasks,
  _ => _.results,
)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Dashboard/dashboardTasksDuck.js